import styled from 'styled-components'

const statusColors = {
  pending: '#ff9140',
  approved: '#36d174',
  expired: '#fd4a4a',
  refused: '#fd4a4a',
  info: '#0093b2',
} as const

export const Container = styled.div`
  width: 100%;
  padding-top: 32px;
`

export const DefaultContainer = styled.div`
  max-width: 600px;
  width: 100%;
  margin: auto;

  .upload-container {
    padding-bottom: 16px;
    border-bottom: 1px solid #ebebeb;

    div[style='text-align: right; width: 100%; margin-left: 50px;'] {
      margin-left: 0 !important;

      .submitButton {
        margin-right: 0;
      }
    }

    .DFtitleUpload {
      display: none;
    }
  }
`
export const TabContainer = styled.div`
  padding-top: 16px;

  li {
    height: 35px !important;
  }

  .DFpagination {
    display: none;
  }
`

export const TabPageContainer = styled.div`
  text-align: left;

  .grid {
    display: grid;
    grid-template-columns: 400px 1fr;
    grid-template-rows: 1fr;
    grid-column-gap: 0px;
    grid-row-gap: 0px;

    .grid-column {
      padding: 8px 24px;
      border-bottom: 1px solid #ebebeb;

      .title {
        margin: 4px 0;
        letter-spacing: 0.5px;
        color: #646464;
      }

      .text,
      span {
        color: #646464;
        letter-spacing: 1px;
        font-size: 14px;
        margin: 4px 0;
        display: block;
      }

      .text {
        font-size: 16px;
      }
    }

    .left {
      text-align: right;
      background-color: #f6f6f6;
    }

    .text-link {
      text-decoration: underline;
      cursor: pointer;
    }

    .right,
    .align-center {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .link {
      display: flex;
      justify-content: space-between;
      align-items: center;

      a {
        text-decoration: underline;
        color: #646464;
        transition: color 0.3s;

        :hover {
          color: #0093b2;
        }
      }
    }
  }

  .table-container {
    table {
      width: 100%;
      border-collapse: collapse;

      thead {
        background-color: #f6f6f6;

        th {
          font-family: Ubuntu, sans-serif;
          font-size: 11px;
          font-weight: 700;
          line-height: 18px;
          letter-spacing: 0.8px;
          color: #646464;
          text-transform: uppercase;
          padding: 4px 8px;

          &:last-child {
            width: 39px;
          }
        }
      }

      tbody {
        td {
          color: #646464;
          font-weight: 700;
          padding: 4px 8px;
          font-size: 14px;

          &:first-child {
            text-align: center;
          }
        }
      }

      .td-right {
        text-align: right;
      }

      .ellipse-text {
        max-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .action {
        display: inline-flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
      }

      .button {
        all: unset;
        height: 32px;
      }
    }

    .dropdown {
      > div {
        margin-left: 0;
        .DFtextField {
          margin-left: 0;
        }
      }
    }
  }
`

export const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 8px 16px;
  gap: 8px;
  background: ${({ type }: { type: string }) => statusColors[type as never]};

  span {
    font-family: Ubuntu, sans-serif;
    font-size: 12px;
    font-weight: 700;
    line-height: 18px;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: white;
  }
`

export const SwitchContainer = styled.div`
  * {
    font-family: Ubuntu, sans-serif;
  }
  .switch-container {
    margin: 24px auto;

    label {
      display: inline-flex;
      align-items: center;
      gap: 16px;
    }

    .text-label {
      color: #646464;
      font-family: Ubuntu, sans-serif;
      letter-spacing: 1px;
      font-size: 16px;
    }
  }
`

export const Spacer = styled.div`
  width: 32px;
  height: 32px;
`
